import type {SearchParams} from 'typings/portaro.be.types';
import type {StateChangeHandler, StateManager} from 'typings/portaro.fe.types';

/**
 * in-memory state manager as factory (we probably dont want to share state between distinct searches)
 */
export function memoryStateManagerFactory() {
    return (() => new MemoryStateManager());
}
memoryStateManagerFactory.factoryName = 'memoryStateManagerFactory'


export class MemoryStateManager implements StateManager {

    private loading = false;
    private readonly stateChangeHandlers: StateChangeHandler[] = [];
    private currentParams: SearchParams = {};

    public isLoading(): boolean {
        return this.loading;
    }

    public register(stateChangeHandler: StateChangeHandler): () => void {
        this.stateChangeHandlers.push(stateChangeHandler);
        return () => this.deregister(stateChangeHandler);
    }

    public requestChangeState(newParams: SearchParams): Promise<void> {
        this.currentParams = newParams;
        return this.locationParamsChanged();
    }

    public requestChangeStateParameter<T extends keyof SearchParams>(parameterName: T, newValue: SearchParams[T]): Promise<void> {

        if (!Object.hasOwn(this.currentParams, parameterName) || this.currentParams[parameterName] !== newValue) {
            this.currentParams[parameterName] = newValue;
            return this.locationParamsChanged();
        }
        return Promise.resolve();
    }

    private deregister(handler): void {
        this.stateChangeHandlers.splice(this.stateChangeHandlers.indexOf(handler), 1);
    }

    private async locationParamsChanged(): Promise<void> {

        this.loading = true;

        try {
            await this.fireAllPromises();
        } finally {
            this.loading = false;
        }
    }

    private fireAllPromises() {
        const promises: PromiseLike<void>[] = this.stateChangeHandlers.map((handler) => handler(this.currentParams));
        return Promise.all(promises);
    }
}